export default {
  '内容形式':'内容形式',
  '发布时间':'发布时间',
  '请输入标题搜索':'请输入标题搜索',
  '封面图':'封面图',
  '备课内容':'备课内容',
  '备课视频':'备课视频',
  '发布设置':'发布设置',
  '支持jpg':'支持jpg/jpeg/png格式，建议比例为4:3，最大不超过5M',
  '请上传封面图':'请上传封面图',
  '请上传备课视频':'请上传备课视频',
  '支持上传mp4格式':'支持上传mp4格式，且视频小于500M。',
  '链接地址':'链接地址',
  '视频描述':'视频描述',
  '标题不可为空':'标题不可为空',
  '内容不可为空':'内容不可为空',
  '确认要停用':'确认要停用',
  '本机构资源空间已不足，请及时联系运营人员':'本机构资源空间已不足，请及时联系运营人员',
}